<template>
  <div class="w-100" ref="affectationsWrapper">
    <div class="d-flex align-items-center justify-content-between my-1">
      <h4 class="mb-0">Información de afectaciones</h4>
      <p class="text-center h4 mb-0">
        Categoría:
        <b-badge variant="primary">{{ branch.category.name }}</b-badge>
      </p>
    </div>
    <div class="row mb-1">
      <div class="col-6" v-if="!isAtm">
        <b-form-group
          label="Afectación de operación"
          label-class="h6 font-weight-normal"
          :label-for="`operation-impact-${branch.id}`"
        >
          <v-select
            :input-id="`operation-impact-${branch.id}`"
            v-model="branch.operation_impact"
            :options="operationImpactOptions"
            placeholder="Seleccione afectación"
            label="label"
            :reduce="(val) => val.value"
            :disabled="isReadOnly"
          />
        </b-form-group>
        <span v-if="branch.errors.operation_impact" class="text-danger">
          {{ branch.errors.operation_impact }}
        </span>
      </div>
      <div class="col-6">
        <b-form-group
          label="Fuera de comunicación"
          label-class="h6 font-weight-normal"
          :label-for="`communication-${branch.id}`"
        >
          <v-select
            :input-id="`communication-${branch.id}`"
            v-model="branch.out_off_comunication"
            :options="communicationOptions"
            placeholder="Seleccione estado de comunicación"
            label="label"
            :reduce="(val) => val.value"
            :disabled="isReadOnly"
          />
          <span v-if="branch.errors.out_off_comunication" class="text-danger">
            {{ branch.errors.out_off_comunication }}
          </span>
        </b-form-group>
      </div>
      <div class="col-6" v-if="!isAtm">
        <b-form-group
          label="Cámaras dañadas"
          label-class="h6 font-weight-normal"
          :label-for="`damaged-cameras-${branch.id}`"
        >
          <b-form-input
            type="number"
            v-model="branch.damaged_cameras"
            min="0"
            :disabled="isReadOnly"
          />
          <span v-if="branch.errors.damaged_cameras" class="text-danger">
            {{ branch.errors.damaged_cameras }}
          </span>
        </b-form-group>
      </div>
      <div class="col-6">
        <b-form-group
          label="Monto de afetación"
          label-class="h6 font-weight-normal"
          :label-for="`affected-amount-${branch.id}`"
        >
          <b-input-group prepend="$">
            <b-form-input
              type="number"
              v-model="branch.affected_amount"
              min="0"
              :disabled="isReadOnly"
            />
          </b-input-group>
          <span v-if="branch.errors.affected_amount" class="text-danger">
            {{ branch.errors.affected_amount }}
          </span>
        </b-form-group>
      </div>
      <div class="col-6" v-if="!isAtm">
        <b-form-group
          label="Sucursal anexa"
          label-class="h6 font-weight-normal"
          :label-for="`sirhnearest-branch-${branch.id}`"
        >
          <v-select
            :input-id="`sirh-nearest-branch${branch.id}`"
            v-model="branch.sirh_nearest_branch"
            :options="units"
            placeholder="Seleccione estado de comunicación"
            label="label"
            :reduce="(val) => val.value"
            :disabled="isReadOnly"
          />
          <span v-if="branch.errors.sirh_nearest_branch" class="text-danger">
            {{ branch.errors.sirh_nearest_branch }}
          </span>
        </b-form-group>
      </div>
    </div>
    <p class="font-weight-bold h6 mb-1" v-if="!isAtm">
      <strong>Filtración de agua y caída de plafones</strong>
    </p>
    <b-row class="mb-2" v-if="!isAtm">
      <b-col
        v-for="(item, idx) in waterLeakOptions"
        :key="idx"
        cols="12" sm="6" md="3"
        class="mb-50"
      >
        <b-form-checkbox
          :name="`option-wlo-${idx}`"
          v-model="branch.affectsUnits"
          :value="item.id"
          :disabled="isReadOnly"
        >
          {{ item.name }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <p class="font-weight-bold h6 mb-1" v-if="!isAtm">
      <strong>Cristales rotos</strong>
    </p>
    <b-row class="mb-2" v-if="!isAtm">
      <b-col
        v-for="(item, idx) in brokenGlassOptions"
        :key="idx"
        cols="12" sm="6" md="3"
        class="mb-50"
      >
        <b-form-checkbox
          :name="`option-bg-${idx}`"
          v-model="branch.affectsUnits"
          :value="item.id"
          :disabled="isReadOnly"
        >
          {{ item.name }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <p class="font-weight-bold h6 mb-1" v-if="isAtm">
      <strong>Daños de ATM</strong>
    </p>
    <b-row class="mb-2" v-if="isAtm">
      <b-col
        v-for="(item, idx) in atmDamagesOptions"
        :key="idx"
        cols="12" sm="6" md="3"
        class="mb-50"
      >
        <b-form-checkbox
          :name="`option-bg-${idx}`"
          v-model="branch.affectsUnits"
          :value="item.id"
          :disabled="isReadOnly"
        >
          {{ item.name }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <p class="font-weight-bold h6 mb-1" v-if="!isAtm">
      <strong>Sistemas de emergencia</strong>
    </p>
    <b-row v-if="!isAtm">
      <b-col
        v-for="(emSysOption, idx) in emergencySystemsOptions"
        :key="idx"
        cols="12" sm="6" md="3"
        class="mb-50"
      >
        <b-form-checkbox
          v-if="emSysOption.model === 'has_emergency_generator'"
          :name="`option-bg-${idx}`"
          v-model="branch.affectsUnits"
          :value="emSysOption.id"
          :disabled="isReadOnly"
        >
          {{ emSysOption.label }}
        </b-form-checkbox>
        <b-form-group
          v-else
          :label="emSysOption.label"
          label-class="h6 font-weight-normal"
          :label-for="`${emSysOption.model}-${branch.id}`"
        >
          <b-form-input
            type="number"
            class="w-25"
            v-model="branch[emSysOption.model]"
            min="0"
            :disabled="isReadOnly"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <span v-if="branch.errors.affectsUnits" class="text-danger">
      {{ branch.errors.affectsUnits }}
    </span>
    <p class="font-weight-bold h6 mb-1" v-if="!isAtm">
      <strong>¿Caminos/vialidades bloqueados?</strong>
    </p>
    <template v-if="!isAtm">
      <b-form-checkbox
        :id="`blocked-roads-${branch.id}`"
        v-model="branch.blocked_roads"
        class="mb-1"
        :disabled="isReadOnly"
      >
        SI
      </b-form-checkbox>
      <b-form-group
        v-if="branch.blocked_roads"
        label="Comentarios sobre caminos/vialidades bloqueados"
        :label-for="`blocked-roads-comments-${branch.id}`"
      >
        <b-form-textarea
          class="mt-1"
          :id="`blocked-roads-comments-${branch.id}`"
          v-model="branch.blocked_roads_comments"
          placeholder="Ingresar comentario"
          rows="3"
          max-rows="6"
          :disabled="isReadOnly"
        ></b-form-textarea>
      </b-form-group>
      <p class="font-weight-bold h6 mb-1">
        <strong>¿Instalación en riesgo?</strong>
      </p>
      <b-form-checkbox
        :id="`in-risk-${branch.id}`"
        v-model="branch.at_risk"
        :disabled="isReadOnly"
      >
        SI
      </b-form-checkbox>
    </template>
    <div v-if="showOptionsByStatus" class="text-right">
      <b-button
        v-if="!isReadOnly"
        class="mt-1"
        variant="primary"
        :disabled="loading"
        @click="$emit('save', branch)"
      >
        Guardar
      </b-button>
    </div>
    <last-risk-evaluation
      class="mt-3"
      v-if="branch.last_risk_evaluation"
      :branch="branch"
    />
  </div>
</template>

<script>
import {computed, onMounted, onBeforeUnmount, ref} from '@vue/composition-api';
import LastRiskEvaluation from "./LastRiskEvaluation.vue";
import vSelect from "vue-select";
import axios from '@/libs/axios';

export default {
  name: "AffectationsTab",
  components: {
    LastRiskEvaluation,
    vSelect,
  },
  props: {
    affectsUnits: {
      type: Array,
      required: true,
    },
    branch: {
      type: Object,
      required: true,
    },
    formStatus: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    showOptionsByStatus: {
      type: Boolean
    }
  },
  setup(props) {
    //DATA
    const affectationsWrapper = ref(null); // Ref for IntersectionObserver
    let observer = null;

    const communicationOptions = ref([
      {value: 'offline', label: 'Offline'},
      {value: 'restore', label: 'Restablece'},
      {value: 'cctv', label: 'CCTV'},
    ]);

    const operationImpactOptions = ref([
      {value: 'total_closure', label: 'Cierre total'},
      {value: 'early_closure', label: 'Cierre anticipado'},
      {value: 'late_opening', label: 'Apertura tardia'}
    ]);

    const units = ref([]);

    //COMPUTED
    const isAtm = computed(() => {
      const category = props.branch?.category?.name?.toLowerCase() || ''
      const keywords = ['atm', 'atms', 'cajero', 'cajeros']

      return keywords.some(keyword => category.includes(keyword))
    });
    const atmDamagesOptions = computed(() => props.affectsUnits.filter(au => au.type === 'atm_damages'));

    const brokenGlassOptions = computed(() => props.affectsUnits.filter(au => au.type === 'broken_glass'));

    const emergencySystemsOptions = computed(() => {
      return props.affectsUnits.filter(au => au.type === 'emergency_systems').map(emsys => {
        const model = {
          'Tiene planta de emergencia': 'has_emergency_generator',
          'Capacidad de la planta': 'emergency_generator_capacity',
          'Nivel de diesel de la planta': 'emergency_generator_diesel_level',
        }

        return {
          id: emsys.id,
          label: emsys.name,
          model: model[emsys.name],
        }
      })
    });

    const waterLeakOptions = computed(() => props.affectsUnits.filter(au => au.type === 'water_leaks_and_falling_ceiling_tiles'));

    //METHODS
    const getUnits = async () => {
      const params = {
        excludedRems: [props.branch.rems],
        municipality: [props.branch.municipality.id]
      }

      await axios.get('v1/unit', {params})
        .then(response => {
          const {data} = response;

          units.value = data.data.filter(unit => unit.sirh)
            .map(unit => ({
              label: unit.description,
              value: unit.sirh
            }));
        })
        .catch(() => {
          units.value = [];
        });
    }

    //HOOKS
    onMounted(() => {
      observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          getUnits();
          observer.disconnect();
        }
      });

      if (affectationsWrapper.value) {
        observer.observe(affectationsWrapper.value);
      }
    });

    onBeforeUnmount(() => {
      if (observer) {
        observer.disconnect();
      }
    });

    return {
      isAtm,
      affectationsWrapper,

      communicationOptions,
      operationImpactOptions,
      units,

      atmDamagesOptions,
      brokenGlassOptions,
      emergencySystemsOptions,
      waterLeakOptions
    }
  }
}
</script>
